export const token = localStorage.getItem('token');

export const userId = localStorage.getItem('user_id');

export const email = localStorage.getItem('user');

export const department = localStorage.getItem('department');

// Static object for backwards compatibility (deprecated - use getAuthHeaderDynamic instead)
export const getAuthHeader = {
  'x-idToken': token || '',
  'x-user_id': userId || '',
  user: email || '',
  'x-department': department || '',
};

// Dynamic function that reads fresh values from localStorage
export const getAuthHeaderDynamic = () => ({
  'x-idToken': localStorage.getItem('token') || '',
  'x-user_id': localStorage.getItem('user_id') || '',
  user: localStorage.getItem('user') || '',
  'x-department': localStorage.getItem('department') || '',
});
